import React from "react";

import { useTheme } from "../../../context/theme";
import useForegroundVariantColor from "../../../styles/colors/surfaces/useForegroundVariantColor";
import { Box, Inline } from "../../layout";
import ToggleButtonOption, { ToggleOption } from "./ToggleButtonOption";

type Props<ValueT> = {
  selectedValue: ValueT;
  options: Array<ToggleOption<ValueT>>;
  onChange: (value: ValueT) => void;
};

export default function ToggleButton<ValueT = string>({
  options,
  selectedValue,
  onChange
}: Props<ValueT>) {
  const theme = useTheme();

  const foregroundVariantColor = useForegroundVariantColor("1");

  return (
    <Box
      dataTest="ToggleButton"
      width="fit-content"
      borderRadius="small"
      padding="xxsmall"
      backgroundColor={foregroundVariantColor}
      borderStyle="solid"
      borderWidth="xxxsmall"
      borderColor={theme["neutral-xLow-content"]}
    >
      <Inline space="small">
        {options.map(({ label, value }: ToggleOption<ValueT>) => (
          <ToggleButtonOption<ValueT>
            key={label}
            selectedValue={selectedValue}
            onChange={onChange}
            label={label}
            value={value}
          />
        ))}
      </Inline>
    </Box>
  );
}
